import React from 'react';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';

import './ProteinVariantIngredientCard.scss';

const ProteinVariantIngredientCard = (props) => {
  const { ingredient } = props;

  return (
    <div id="proteinvariantingredientcard-wrapper" className="ingredient-card-container">
      <div id="proteinvariantingredientcard-container" className="ingredient-card-icon">
        <RMSvgIcon
          id="proteinvariantingredientcard-svg-formulation-icon"
          name="ProteinFormulation"
          fill="#414042"
          height="1.75rem"
          width="1.75rem"
        />
      </div>
      <div
        id={`proteinvariantingredientcard-content-${ingredient.id}`}
        className="ingredient-card-content"
      >
        <div
          id={`proteinvariantingredientcard-title-${ingredient.name}`}
          className="ingredient-card-content-protein-name"
        >
          {ingredient.name || 'Protein'}
        </div>
        <div
          id={`proteinvariantingredientcard-subtitle-${ingredient.concentrationmgmL}`}
          className="ingredient-card-content-protein-detail"
        >
          Conc: {ingredient.concentrationmgmL || '0'} mg/mL,{' '}
          {ingredient.concentrationmM || '0'} mM, {ingredient.molecularWeight || '0'} kDa
        </div>
      </div>
    </div>
  );
};

export default ProteinVariantIngredientCard;
